"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportSessionsFiltersDtoValidation = exports.SearchQueryValidationDto = exports.DeleteSessionsDtoValidation = exports.ClubType = void 0;
const app_1 = require("./app");
const yup = require("yup");
var ClubType;
(function (ClubType) {
    ClubType["Driver"] = "Driver";
    ClubType["Putter"] = "Putter";
})(ClubType = exports.ClubType || (exports.ClubType = {}));
exports.DeleteSessionsDtoValidation = yup.object({
    ids: yup.array().of(yup.number()).min(1).required(),
});
exports.SearchQueryValidationDto = yup.object({
    page: yup.number(),
    pageSize: yup.number(),
    email: yup.string(),
    sort: yup.object({
        key: yup.string(),
        order: yup.mixed().oneOf([app_1.SortOrder.ASC, app_1.SortOrder.DESC]),
    }),
});
exports.ExportSessionsFiltersDtoValidation = yup.object({
    dateFrom: yup.string().notRequired().nullable(),
    dateTo: yup.string().notRequired().nullable(),
    dataModeTraining: yup.boolean().notRequired(),
    dataModeViewer: yup.boolean().notRequired(),
    dataModeUser: yup.boolean().notRequired(),
    handRight: yup.boolean().notRequired(),
    handLeft: yup.boolean().notRequired(),
    genderMale: yup.boolean().notRequired(),
    genderFemale: yup.boolean().notRequired(),
    skillLevelBeginner: yup.boolean().notRequired(),
    skillLevelIntermediate: yup.boolean().notRequired(),
    skillLevelAdvanced: yup.boolean().notRequired(),
    driver: yup.boolean().notRequired(),
    putter: yup.boolean().notRequired(),
    sessionIds: yup.array().of(yup.number()).notRequired(),
});
//# sourceMappingURL=session.js.map